import { MessageCircle } from "lucide-react";
import { trackConversion } from "@/lib/tracking-events";

export const WHATSAPP_URL =
  "https://wa.me/351934371241?text=" +
  encodeURIComponent("Olá, gostaria de receber uma proposta para o meu imóvel.");

export function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar connosco no WhatsApp"
      onClick={() => trackConversion("Contact", { method: "whatsapp" })}
      className="fixed bottom-20 right-5 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 transition-transform hover:scale-105 md:bottom-24 md:right-8"
    >
      <MessageCircle className="h-7 w-7" strokeWidth={2.2} />
    </a>
  );
}
